import { createAction, props } from '@ngrx/store';
import {
  DataPersonEntity,
  DataPersonName,
  DataStartedAt,
} from '@edgvr-front/data/domain';

export const init = createAction('[Data Person / Persons List Page] Init');
export const destroy = createAction(
  '[Data Person / Persons List Page] Destroy'
);

export const dataPersonsList = createAction(
  '[Data Person / Persons List Page] Data Persons List',
  props<{
    page: number;
    personName?: DataPersonName;
    from?: DataStartedAt;
    to?: DataStartedAt;
  }>()
);
export const dataPersonsListSuccess = createAction(
  '[Data Person / Persons List Page] Data Persons List Success',
  props<{ dataPersons: DataPersonEntity[]; count: number; page: number }>()
);
export const dataPersonsListFailure = createAction(
  '[Data Person / Persons List Page] Data Persons List Failure'
);
